import * as React from 'react';
import * as ReactDOM from 'react-dom';
import IconTextButton from "diy/custom-components/icon-text-button/IconTextButton";
import IconButton from "material-ui/IconButton";
import Popover from "material-ui/Popover/Popover";

type SvgIconClass = typeof __MaterialUI.SvgIcon;

import KeyboardArrowDownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

export interface DropdownProps {
    text?: string;
    Icon: React.ReactElement<__MaterialUI.SvgIconProps>;
    disabled?: boolean;
    open?: boolean;
    dataTestId?: string;
    buttonStyle?: React.CSSProperties;
    layerStyle?: React.CSSProperties;
    horizontalAlign?: 'left'|'middle'|'right';
    onClose?(): void;
    onOpen?(): void;
}

interface DropdownState {
    open: boolean;
}

export class Dropdown extends React.Component<DropdownProps, DropdownState> {
    static defaultProps = {
        horizontalAlign: 'left'
    };

    private buttonEl: HTMLElement;

    constructor(props: DropdownProps, context?: any) {
        super(props, context);

        this.state = {
            open: props.open || false
        };
    }

    componentWillReceiveProps(nextProps: DropdownProps) {
        if (nextProps.open !== this.props.open) {
            this.setState({
                open: nextProps.open
            });
        }
    }

    render() {
        return (
            <div style={{marginRight: 12}}>
                {this.renderButton()}
                <Popover
                    open={this.state.open}
                    anchorEl={this.buttonEl}
                    className="diy-material-dropdown-popover"
                    style={this.props.layerStyle}
                    useLayerForClickAway={true}
                    anchorOrigin={{"horizontal": this.props.horizontalAlign,"vertical": "bottom"}}
                    targetOrigin={{"horizontal": this.props.horizontalAlign,"vertical": "top"}}
                    onRequestClose={() => this.onLayerClose()}
                >
                    <div data-test-id={`${this.props.dataTestId}-flyout`}>
                        {this.props.children}
                    </div>
                </Popover>
            </div>
        );
    }

    private renderButton() {
        let testId = `${this.props.dataTestId}-button`;
        let baseButtonProps = {
            style: Object.assign({
                display: 'block'
            }, this.props.buttonStyle)
        };

        if (!this.props.text) {
            return (
                <IconButton
                    onTouchTap={() => this.onButtonClick()}
                    ref={(ref: IconButton) => this.buttonEl = ReactDOM.findDOMNode(ref) as HTMLElement}
                    data-test-id={testId}
                    {...baseButtonProps}
                >
                    {this.props.Icon}
                </IconButton>
            );
        }

        return (
            <IconTextButton
                text={this.props.text}
                Icon={this.props.Icon}
                ref={(ref: IconTextButton) => this.buttonEl = ReactDOM.findDOMNode(ref) as HTMLElement}
                onTouchTap={() => this.onButtonClick()}
                useAlternativeColors={true}
                isPressed={this.state.open}
                isDisabled={this.props.disabled}
                AdditionalIcon={KeyboardArrowDownIcon}
                dataTestId={testId}
                {...baseButtonProps}
            />
        );
    }

    private onButtonClick() {
        // do not use a negation of the previous state -
        // this should only open the menu - the overlay will close it
        // the button is only accessible when the overaly is gone
        // material ui android issue: generates 2nd click on the layer
        // which closes the menu
        // https://github.com/callemall/material-ui/issues/3335
        this.setState({
            open: true
        });
        if (this.props.onOpen) {
            this.props.onOpen();
        }
    }

    private onLayerClose() {
        this.setState({
            open: false
        });
        if (this.props.onClose) {
            this.props.onClose();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/toolbar/Dropdown.tsx
 **/